export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "menu-open-options": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir le menu"])}
      },
      "en": {
        "menu-open-options": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open menu"])}
      }
    }
  })
}
